<template>
  <div class="flex items-center h-16 pl-4 space-x-4 ledge">
    <StreamLogo v-if="!noLogo" />
  </div>
</template>

<script>
import StreamLogo from "@/components/Interactive/StreamLogo";


export default {
  props: {
    noLogo: {
      type: Boolean,
      default: false
    }
  },

  components: {
    StreamLogo,
  }
};
</script>

<style scoped>
.ledge {
  background-image: url("~@/assets/images/brick.png");
}
</style>
